var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLaptop({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic-laptop",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 12.6,
    viewBox: "0 0 18 12.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "laptop-solid_1_",
    "data-name": "laptop-solid (1)",
    d: "M3.6,32a1.8,1.8,0,0,0-1.8,1.8V41H3.6V33.8H14.4V41h1.8V33.8A1.8,1.8,0,0,0,14.4,32ZM.54,41.9a.54.54,0,0,0-.54.54A2.161,2.161,0,0,0,2.16,44.6H15.84A2.161,2.161,0,0,0,18,42.44a.54.54,0,0,0-.54-.54Z",
    transform: "translate(0 -32)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLaptop);
export default __webpack_public_path__ + "static/media/ic-laptop.9e1635fc3513e0d3dc4032e00e119afd.svg";
export { ForwardRef as ReactComponent };